import { createCrewLookupSelect } from './createCrewLookupSelect';

export const RelationSelect = createCrewLookupSelect('RelationSelect', 'relations');
export default RelationSelect;
